// @flow
import React from "react";
import SelecaoRadioBaseComTraducao from "../../../comum/SelecaoRadioBaseComTraducao";
import {
  selecionarVersaoConta,
  getVersaoContaSelecionada,
  getVersoesConta,
} from "../../../../state";

export default function SelecaoVersaoConta() {
  return (
    <div className="ConfiguracaoMedida">
      <SelecaoRadioBaseComTraducao
        chaveTraducaoNomeSelecao={"versao"}
        itensSelector={getVersoesConta}
        selectorItemSelecionado={getVersaoContaSelecionada}
        onItemChange={selecionarVersaoConta}
        campoId="codigo"
        campoChaveTraducao="descricao"
      />
    </div>
  );
}
